<template>
  <div>
    <Dropdown>
      <template v-slot:dropdown-button>
        <button class="text-gray-500 hover:text-gray-700 mr-2 w-6 h-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="size-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
            />
          </svg>
        </button>
      </template>
      <template v-slot:dropdown-content>
        <div class="py-1">
          <a
            v-for="reply in savedReplies"
            :key="reply.id"
            class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900 cursor-pointer"
            role="menuitem"
            @click="selectReply(reply)"
          >
            {{ reply.name }}
          </a>
          <a
            class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900 cursor-pointer flex items-center"
            role="menuitem"
            @click="openAddModal"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-6 w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 4.5v15m7.5-7.5h-15"
              />
            </svg>

            Add Saved Reply
          </a>
          <a
            class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900 cursor-pointer flex items-center"
            role="menuitem"
            @click="openManageModal"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-6 w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M4.5 12a7.5 7.5 0 0 0 15 0m-15 0a7.5 7.5 0 1 1 15 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077 1.41-.513m14.095-5.13 1.41-.513M5.106 17.785l1.15-.964m11.49-9.642 1.149-.964M7.501 19.795l.75-1.3m7.5-12.99.75-1.3m-6.063 16.658.26-1.477m2.605-14.772.26-1.477m0 17.726-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205 12 12m6.894 5.785-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495"
              />
            </svg>
            Manage Saved Replies
          </a>
        </div>
      </template>
    </Dropdown>

    <AddSavedReplyModal :isOpen="isAddModalOpen" @close="closeAddModal" />
    <ManageSavedRepliesModal
      :isOpen="isManageModalOpen"
      @close="closeManageModal"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Dropdown from "./Dropdown.vue";
import AddSavedReplyModal from "./AddSavedReplyModal.vue";
import ManageSavedRepliesModal from "./ManageSavedRepliesModal.vue";

export default {
  components: {
    Dropdown,
    AddSavedReplyModal,
    ManageSavedRepliesModal
  },
  data() {
    return {
      isAddModalOpen: false,
      isManageModalOpen: false
    };
  },
  computed: {
    ...mapState("Inbox", ["savedReplies"])
  },
  methods: {
    ...mapActions("Inbox", ["createSavedReply"]),
    selectReply(reply) {
      this.$emit("replySelected", reply.content);
    },
    openAddModal() {
      this.isAddModalOpen = true;
    },
    closeAddModal() {
      this.isAddModalOpen = false;
    },
    openManageModal() {
      this.isManageModalOpen = true;
    },
    closeManageModal() {
      this.isManageModalOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
